import { Dto, DtoWithId } from "@mango/core";


@Dto({fullName: "CIJBorculo.Logic.TypeCalculatie"})
export class TypeCalculatie extends DtoWithId {
	omschrijving: string;
	centixPlanID: string;
	isActief:boolean;
}